module.exports = __webpack_public_path__ + "img/nameserve.41fea874.jpg";